import React from 'react'
import { Modal } from 'is24-corecss'
import { useTranslation } from 'react-i18next'
import { AiEmptyUploadImageSection } from './AiEmptyUploadImageSection'
import { AiEmptyUploadDocumentSection } from './AiEmptyUploadDocumentSection'

interface AiDataExtractionUploadModalProps {
  isOpen: boolean
  onClose: () => void
}

export const AiDataExtractionUploadModal = ({ isOpen, onClose }: AiDataExtractionUploadModalProps) => {
  const { t } = useTranslation()

  const onFileSelect = (_files: FileList | null) => {
    // Implementation will be connected to upload flow in a follow-up ticket.
  }

  const primaryFooterBtn = (
    <Modal.FooterPrimaryBtn
      label={t('wizard.uploadAiBanner.modal.uploadButton')}
      onClick={() => undefined}
      variant='filledDefault'
    />
  )
  const secondaryFooterBtn = (
    <Modal.FooterSecondaryBtn label={t('wizard.uploadAiBanner.modal.cancelButton')} onClick={onClose} />
  )

  return (
    <Modal
      visible={isOpen}
      ariaLabelCloseButton='close'
      title={t('wizard.uploadAiBanner.modal.title')}
      onClose={onClose}
      secondaryFooterBtn={secondaryFooterBtn}
      primaryFooterBtn={primaryFooterBtn}
      width={720}
    >
      <p className='font-body-medium-regular margin-bottom-l'>{t('wizard.uploadAiBanner.modal.description')}</p>
      <AiEmptyUploadImageSection onFileSelect={onFileSelect} />
      <AiEmptyUploadDocumentSection onFileSelect={onFileSelect} />
    </Modal>
  )
}
